import React from 'react';
import Component from '../../component/Component';

class Content extends Component {
  render() {
    return (
      <div
        style={{
          display: 'flex',
          alignItems: 'center'
        }}
      >
        <div className={'tp-icon tp-loop'} />
        <span
          // <debug>
          data-cy={'download-indicator-label'}
          // </debug>
        >{this.translate('pleaseWait')}</span>
      </div>
    );
  }
}

export default Content;
